import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { useExtensionContext } from "../modules/extension/ExtensionContext";
import { apiErrorText } from "app/popleads/networking/apiErrorText";
const useOlanakDurumDegistir = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { setSelectedDeal, selectedDeal, refetchDeals } = useExtensionContext();

    const olanakDurumDegistir = async ({ id, profil, durum, lastStatus, kapanmaTarihi, nationalIdNumber }) => {
        setLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "olanakDurumDegistir",
                id,
                profil,
                durum,
                lastStatus,
                kapanmaTarihi,
                nationalIdNumber: nationalIdNumber || "",
            });

            if (response.status === 200) {
                //toast.success("Status has been changed!");
                const deal = { ...selectedDeal };
                deal.durum = durum;
                deal.lastStatus = durum; // Yeni durum artık bir sonraki değişiklik için lastStatus olacak
                setSelectedDeal(deal);
                //refetchProfile();
                refetchDeals();
            } else {
                toast.error(apiErrorText(response));
            }
            return response;
        } catch (err) {
            toast.error(apiErrorText(err));
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, olanakDurumDegistir };
};

export default useOlanakDurumDegistir;
